import { AsyncPipe, CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    output,
    TemplateRef,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgbDropdownModule, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { AiChatPanelService } from '../../../features/ai-chat/services/ai-chat-panel.service';
import { QaPanelService } from '../../../features/qa-controls/qa-panel.service';
import { hasPermission } from '../../utils/auth/has-permission';
import {
    FeatureFlagService,
    KnownFeatureFlags,
} from '../../utils/feature-flags/feature-flag.service';
import { TitleLogoComponent } from '../title-logo/title-logo.component';

@Component({
    selector: 'acm-header',
    imports: [
        CommonModule,
        MatIcon,
        NgbDropdownModule,
        RouterLink,
        RouterLinkActive,
        TitleLogoComponent,
        AsyncPipe,
    ],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
    protected readonly featureFlags = inject(FeatureFlagService);
    protected readonly flags = KnownFeatureFlags;
    protected readonly qaPanel = inject(QaPanelService);
    protected readonly aiChatPanel = inject(AiChatPanelService);
    private readonly offcanvasService = inject(NgbOffcanvas);

    protected readonly canReadPartner$ = hasPermission('partner', 'read');
    protected readonly canReadPartnerServices$ = hasPermission('partnerServices', 'read');

    /**
     * Identifies the user. Overloaded to also communicate login status
     */
    readonly user = input<null | undefined | { displayName: string; displayInitials: string }>();

    readonly logoutEvent = output<void>();

    readonly isProd = input(false);

    readonly envDisplayName = input('Unknown');

    readonly appName = 'Aperture Credential Management';

    openMainNav(content: TemplateRef<unknown>) {
        this.offcanvasService.open(content, { ariaLabelledBy: 'main-navigation' });
    }
}
